export default __webpack_public_path__ + "b59efea44f31f34aba09b77f1284fdc6.svg";